<template>
  <div>
    <!-- {{ user.interview }} -->
    <h4 v-if="interview">Interview Time: {{ new Date(interview).toDateString() }} at {{ new Date(interview).toLocaleTimeString() }}</h4>
    <div class="row field-of-fields">
      <div class="col-lg-6">
        <label class="top-label">Interview Date</label>
        <datepicker :disabled-dates="disabledDates" class="form-control" id="signedDate" v-model="date" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
      </div>
      <div class="col-lg-6">
        <label class="top-label">Interview Time</label>
        <!-- <input type="text" class="form-control" v-model="time"> -->
        <div class="input-group">
          <select class="form-control" v-model="startHour">
            <!-- <option>HH</option> -->
            <option v-for="(hour, index) in hourOptions" :key="'StartHour'+index">{{ hour }}</option>
          </select>
          <select class="form-control" v-model="startMinute">
            <!-- <option>MM</option> -->
            <option v-for="(minute, index) in minuteOptions" :key="'StartMinute'+index">{{ minute }}</option>
          </select>
          <select class="form-control" v-model="startAMPM">
            <option v-for="(ampm, index) in ampmOptions" :key="'StartAMPM'+index">{{ ampm }}</option>
          </select>
        </div>
      </div>
    </div>
    <button v-if="date" class="mylisting-button dark-button mt-3" @click="setInterview()">Set Interview</button>
  </div>
</template>

<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

export default {
  props: ['user'],
  components: {
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      date: null,
      time: '',
      interview: null,

      startHour: 1,
      startMinute: '00',
      startAMPM: 'AM',
      startTime: null,
      // endHour: 1,
      // endMinute: '00',
      // endTime: null,
      // endAMPM: 'AM',
      hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      ampmOptions: ['AM', 'PM'],
    }
  },
  computed: {
    disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      let today = new Date()
      let disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
      return disabledDates
    },
  },
  created() {
    // this.date = this.user.date1
    // this.time = this.user.text16
    this.interview = this.user.interview
  },
  methods: {
    setInterview() {
      this.startHour = parseInt(this.startHour)
      if (this.startHour == 12) {
        this.startHour -= 12
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        console.log(this.startHour)
        this.startHour += 12
        console.log(this.startHour)
      }
      this.startHour = ("0" + this.startHour).slice(-2);
      console.log(this.startHour)

      let interview = this.dateInDjangoFormat(this.date)+'T'+this.startHour+':'+this.startMinute+':00'

      axios.patch(`/api/people/${this.user.id}/`, {
        // interview: this.date,
        interview: interview,
      })
        .then(res => {
          // this.interview = this.date
          this.interview = interview
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/agents/functions/InterviewScheduler.vue